import { useState, useEffect } from "react"

export default function OverlayLoader(props) {
  const [ show, setShow ] = useState(props.show);

  useEffect(() => {
    setShow(props.show);
  }, [ props.show ]);

  return (
    <div className='OverlayLoader' style={{ display: (show) ? "block":"none" }}>
      <div className='Loader'></div>
    </div>
  )
}